import React from 'react';

import Hero from './Hero';
import Services from './Services';
import DeliveryModel from './DeliveryModel';
import About from './About';
import ContactForm from './ContactForm';

export default function Home() {
  return (
    <>
      <Hero />
      <Services />
      <DeliveryModel />
      <About />
      <ContactForm />
    </>
  );
}